customElements.get("product-form")||customElements.define("product-form",class extends HTMLElement{constructor(){super(),this.originalButtonText="",this.persistentTextActive=!1}connectedCallback(){setTimeout((()=>{if(this.form=this.querySelector("form"),!this.form)return;const t=this.variantIdInput;if(t&&(t.disabled=!1),this.form.addEventListener("submit",this.onSubmitHandler.bind(this)),this.cart=document.querySelector("cart-notification")||document.querySelector("cart-drawer"),this.submitButton=this.querySelector('[type="submit"]'),this.submitButton){if(this.submitButtonText=this.submitButton.querySelector(".button-text"),this.submitButtonText&&(this.originalButtonText=this.submitButtonText.textContent,this.submitButton.dataset.originalText=this.originalButtonText),"true"===this.submitButton.dataset.textOverride&&this.submitButtonText);else if(this.submitButton.classList.contains("has-persistent-text")&&this.submitButtonText){this.persistentTextActive=!0;const t=this.submitButton.dataset.persistentText;if(t)this.submitButtonText.textContent=t,localStorage.setItem("addToCartButtonText",t);else{const t=localStorage.getItem("addToCartButtonText");t&&(this.submitButtonText.textContent=t,this.submitButton.dataset.persistentText=t)}}(this.persistentTextActive||"true"===this.submitButton.dataset.textOverride)&&this.submitButtonText&&this.setupButtonTextObserver(),document.querySelector("cart-drawer")&&this.submitButton.setAttribute("aria-haspopup","dialog"),this.hideErrors="true"===this.dataset.hideErrors,document.addEventListener("variant:change",this.handleVariantChange.bind(this))}}),100)}setupButtonTextObserver(){if(!this.submitButtonText)return;const t={characterData:!0,childList:!0,subtree:!0};if(this.persistentTextActive){const e=this.submitButton.dataset.persistentText||localStorage.getItem("addToCartButtonText");if(!e)return;this.buttonTextObserver=new MutationObserver((t=>{this.submitButtonText.textContent!==e&&(this.submitButtonText.textContent=e)})),this.buttonTextObserver.observe(this.submitButtonText,t)}}handleVariantChange(t){this.submitButtonText&&setTimeout((()=>{if(this.persistentTextActive){const t=this.submitButton.dataset.persistentText||localStorage.getItem("addToCartButtonText");t&&(this.submitButtonText.textContent=t)}}),50)}onSubmitHandler(t){if(t.preventDefault(),"true"===this.submitButton.getAttribute("aria-disabled"))return;  if(typeof enforceRapiBundleMinQuantity != "undefined"){enforceRapiBundleMinQuantity(this.form);} this.handleErrorMessage(),this.submitButton.setAttribute("aria-disabled",!0),this.submitButton.classList.add("loading"),this.querySelector(".loading__spinner").classList.remove("hidden");const e=fetchConfig("javascript");e.headers["X-Requested-With"]="XMLHttpRequest",delete e.headers["Content-Type"];const s=new FormData(this.form);this.cart&&"function"==typeof this.cart.getSectionsToRender&&(s.append("sections",this.cart.getSectionsToRender().map((t=>t.id))),s.append("sections_url",window.location.pathname),this.cart.setActiveElement(document.activeElement)),e.body=s,fetch(`${routes.cart_add_url}`,e).then((t=>t.json())).then((t=>{if(t.status){publish(PUB_SUB_EVENTS.cartError,{source:"product-form",productVariantId:s.get("id"),errors:t.errors||t.description,message:t.message}),this.handleErrorMessage(t.description);const e=this.submitButton.querySelector(".sold-out-message");if(!e)return;return this.submitButton.setAttribute("aria-disabled",!0),this.submitButtonText.classList.add("hidden"),e.classList.remove("hidden"),void(this.error=!0)}if(!this.cart)return void(window.location=window.routes.cart_url);const e=CartPerformance.createStartingMarker("add:wait-for-subscribers");this.error||publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form",productVariantId:s.get("id"),cartData:t}).then((()=>{CartPerformance.measureFromMarker("add:wait-for-subscribers",e)})),this.error=!1;const i=this.closest("quick-add-modal");i?(document.body.addEventListener("modalClosed",(()=>{setTimeout((()=>{CartPerformance.measure("add:paint-updated-sections",(()=>{("function"==typeof this.cart.renderContents)&&this.cart.renderContents(t)}))}))}),{once:!0}),i.hide(!0)):CartPerformance.measure("add:paint-updated-sections",(()=>{("function"==typeof this.cart.renderContents)&&this.cart.renderContents(t)}))})).catch((t=>{console.error(t)})).finally((()=>{if(this.submitButton.classList.remove("loading"),this.cart&&this.cart.classList.contains("is-empty")&&this.cart.classList.remove("is-empty"),this.error||this.submitButton.removeAttribute("aria-disabled"),this.querySelector(".loading__spinner").classList.add("hidden"),this.error||"true"!==this.submitButton.dataset.textOverride){if(!this.error&&this.persistentTextActive){const t=this.submitButton.dataset.persistentText||localStorage.getItem("addToCartButtonText");t&&this.submitButtonText&&(this.submitButtonText.textContent=t)}}else;CartPerformance.measureFromEvent("add:user-action",t)}))}handleErrorMessage(t=!1){this.hideErrors||(this.errorMessageWrapper=this.errorMessageWrapper||this.querySelector(".product-form__error-message-wrapper"),this.errorMessageWrapper&&(this.errorMessage=this.errorMessage||this.errorMessageWrapper.querySelector(".product-form__error-message"),this.errorMessageWrapper.toggleAttribute("hidden",!t),t&&(this.errorMessage.textContent=t)))}toggleSubmitButton(t=!0,e){if(t)this.submitButton.setAttribute("disabled","disabled"),e&&(this.submitButtonText.textContent=e);else{if(this.submitButton.removeAttribute("disabled"),"true"===this.submitButton.dataset.textOverride);else if(this.persistentTextActive){const t=this.submitButton.dataset.persistentText||localStorage.getItem("addToCartButtonText");if(t)return void(this.submitButtonText.textContent=t)}this.originalButtonText?this.submitButtonText.textContent=this.originalButtonText:this.submitButton.dataset.originalText?this.submitButtonText.textContent=this.submitButton.dataset.originalText:this.submitButtonText.textContent=window.variantStrings.addToCart}}disconnectedCallback(){this.buttonTextObserver&&this.buttonTextObserver.disconnect(),document.removeEventListener("variant:change",this.handleVariantChange)}get variantIdInput(){return this.form.querySelector("[name=id]")}});
// code added by RAPI
function getOfferMinQuantity(offer) {
  if (!offer) return 1;

  const discountType = String(
    offer.discount_type ?? offer.discountType ?? "none"
  ).toLowerCase();

  if (discountType === "buyxgety") {
    const x = parseInt(offer.xqty ?? 1, 10) || 1;
    const y = parseInt(offer.yqty ?? 1, 10) || 1;
    return Math.max(1, x + y);
  }

  const qty = parseInt(offer.quantity ?? 1, 10);
  return Number.isFinite(qty) && qty > 0 ? qty : 1;
}

function getRapiMarketCode() {
  const fromInput = document.getElementById("rappi-country-code")?.value;
  const fromShopify = typeof Shopify !== "undefined" ? Shopify?.country : "";
  return String(fromShopify || fromInput || "").trim().toUpperCase();
}

function isBundleAllowedForMarket(bundle) {
  const targetMarkets = bundle?.target_markets;
  if (!Array.isArray(targetMarkets) || targetMarkets.length === 0) return true;

  const current = getRapiMarketCode();
  if (!current) return false;

  return targetMarkets.some(
    (m) => String(m).trim().toUpperCase() === current
  );
}

function appendFormPropertyIfMissing(form, key, value) {
  if (!form || value == null || value === "") return;

  const name = `properties[${key}]`;
  const existing = form.querySelector(`[name="${name}"]`);

  if (existing && existing.value) return;

  let input = existing;

  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    form.appendChild(input);
  }

  input.value = String(value);
}

function ensureRapiBundleFormProperties(form, bundle) {
  if (!form || !bundle?.id) return;
  if (!isBundleAllowedForMarket(bundle)) return;

  appendFormPropertyIfMissing(form, "_rapi_bundles", bundle.id);

  const market = getRapiMarketCode();
  if (market) {
    appendFormPropertyIfMissing(form, "_rapi_market", market);
  }

  if (bundle.ab_test_started_at && !bundle.ab_test_ended_at && bundle.uuid) {
    appendFormPropertyIfMissing(form, "_rapi_session_id", bundle.uuid);
  }
}

/* Plancher applique quand la config Rapi n'est pas lisible au moment du submit.
   Regle marchand : une commande ne doit JAMAIS partir avec un seul kit.

   var et non const : ce fichier est charge deux fois sur la page produit
   (une fois par layout/theme.liquid, une fois par la section produit). Un const
   de premier niveau lance alors "Identifier has already been declared" et tue
   la seconde execution du fichier. */
var RAPI_ABSOLUTE_MIN_QTY = 2;

function enforceRapiBundleMinQuantity(form) {
  if (!form) return;

  /* Le selecteur d'offres est rendu : il gere lui-meme la quantite.
     .rapi-bundles = rendu par l'app Rapi, .bn = selecteur natif du theme.

     Le cas .bn est indispensable depuis l'ajout du bloc sur la creme : ses
     offres commencent a 1 unite, alors que le plancher de secours ci-dessous
     est fixe a 2 (regle propre au DermaGlow). Sans cette sortie, choisir
     "1 CREMA" mettait 2 cremes au panier. */
  if (document.querySelector(".rapi-bundles, .bn")) return;

  let bundle = null;
  try {
    bundle = typeof _qbrb === "undefined" ? null : _qbrb?.bundle ?? null;
  } catch (e) {
    bundle = null;
  }

  /* --- Correctif ---------------------------------------------------------
     La version precedente sortait ici des que _qbrb etait absent. Or _qbrb
     n'existe qu'une fois l'app Rapi chargee : la fonction ne faisait donc
     rien dans le seul cas ou elle servait a quelque chose (clic rapide,
     Android lent). C'est ce qui produisait les commandes a 1 article, avec
     "quantity field: none" dans les logs.
     On applique desormais un plancher meme sans _qbrb.
     ---------------------------------------------------------------------- */
  let minQty = RAPI_ABSOLUTE_MIN_QTY;

  if (bundle?.id) {
    if (bundle.different_variants_enabled) return;

    const offerQuantities = (bundle.offers || [])
      .map((o) => getOfferMinQuantity(o))
      .filter((q) => Number.isFinite(q) && q > 0);

    if (offerQuantities.length) {
      minQty = Math.min(...offerQuantities);
    }

    ensureRapiBundleFormProperties(form, bundle);
  }

  if (minQty <= 1) return;

  let qtyInput = form.querySelector('[name="quantity"]');

  if (!qtyInput) {
    qtyInput = document.createElement("input");
    qtyInput.type = "hidden";
    qtyInput.name = "quantity";
    qtyInput.value = String(minQty);
    form.appendChild(qtyInput);
    return;
  }

  const currentQty = parseInt(qtyInput.value, 10) || 1;
  if (currentQty >= minQty) return;

  qtyInput.value = String(minQty);
  qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
  qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
}